import { Component, OnInit,ViewChild } from '@angular/core';
import { AuthService } from 'src/app/services/auth.service';
import { NgxChartsModule } from '@swimlane/ngx-charts';
//import { NgxGraphModule } from '@swimlane/ngx-graph';
import { Router } from '@angular/router';
import * as shape from 'd3-shape';
import { Subject } from 'rxjs';
import {
  trigger,
  state,
  style,
  animate,
  transition
} from '@angular/animations';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ddf2',
  templateUrl: './ddf2.component.html',
  styleUrls: ['./ddf2.component.scss']
})
export class Ddf2Component implements OnInit {

  curveType: string = 'Bundle';
  @ViewChild('subch',null) subch;
  curve: any = shape.curveLinear;
  public loading = false; 
  model:any={};
  url;
  id_cliente=0;
  constructor(
    public authService: AuthService,
    public router: Router){ 
    
    try {
      var c=this.router.url;
      var c2=c.split("?");      
      this.raci_id=Number(c2[1].replace("=",""));
      //console.log("1.-"+this.raci_id)
      if(this.raci_id==undefined){
        this.raci_id=237//Number(localStorage.getItem("id_raci"))        
      }
    } catch (error) {
      this.raci_id=237//Number(localStorage.getItem("id_raci"))
    }    
    //console.log(this.raci_id)
  }
  nodes = [];  
  nodes_aux = [];  
  links =[];
  links_aux =[];
  matriz_p=[]
  rel_pa=[]
  procesos=[]
  matriz_ap=[]
  area=[]
  raci_id=0;
  rel_pa_C=[]
  raciname;
  bnd_from_raci=false
  bndlst_ddf=false;
  racsi=[{id:237,titulo:" Desarrollo de Sotfware (ejemplo )"},
  {id:236,titulo:" Desarrollo"}]
  vddf(itm){
    console.log(itm)
    this.raci_id=itm.id
    this.load_graph();
    this.bndlst_ddf=false;
    //this.router.navigate(["/login?"+itm.id])
    this.router.navigateByUrl("/?"+itm.id)
    

  }
  vlst_dfd(){
    if(this.bndlst_ddf==true){
      this.bndlst_ddf=false;
    }else{
      this.bndlst_ddf=true;
    }
  }
  async ddf(){
    await this.raci_data();
    await this.load_graph();
    //console.log("si")
    //console.log(this.nodes)
    if(this.nodes.length==0){
      //console.log("no")
      await this.load_from_Raci();  
      this.subch.nativeElement.click();
      //this.load_graph();
    }    
  }

   ngOnInit() {
    //this.id_cliente=Number(localStorage.getItem("cliente"));
    this.ddf();
   //console.log(this.links)
  }
  raci_data(){
     this.authService.service("/api/get_raci_id",{id:this.raci_id})
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        try {
          this.raciname="["+res[0].id+"] "+res[0].descipcion;  
        } catch (error) {
          this.raciname="";
        }               
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de);
      });
  }
  async load_graph(){   
    console.log(this.raci_id)
    await this.authService.service("/api/get_nodes_graph",{id_raci:this.raci_id})
    .then(
      data => {                       
        //this.nodes=data
        for(var i=0;i<data.length;i++){          
          this.nodes.push({id: data[i].id.toString(),
            label: "A",
            role: data[i].titulo,
            class:data[i].class,
            btn:true}
            )
        }  
        //console.log(this.nodes)    
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de);
    });      
    await this.authService.service("/api/get_links_graph",{id_raci:this.raci_id})
    .then(
      data => {
        //console.log(data)                  
        for(var i=0;i<data.length;i++){
          this.links.push(
            {id: "l"+data[i].id, 
              source:data[i].source,
              target: data[i].target,
              label: 'dd' })         
        }      
    },
    error => {
        var de= JSON.stringify(error);
        var di = JSON.parse(de);
    }); 
    //console.log(this.nodes);  
    //this.links = [...this.links];
    //this.nodes = [...this.nodes];     
  }
  async  load_from_Raci(){
//source:target:label:
  var id_previni="0"
  var id_prev="0"
  var id_prevfin="0"

    await this.authService.service("/api/ins_nodes_graph",{ id_raci:this.raci_id, titulo:"Inicio", class:"ddf_inicio", area:0,proceso:0})
      .then(  data => {id_previni=data.insertId;  });
    await this.authService.service("/api/ins_nodes_graph",{ id_raci:this.raci_id, titulo:"Fin", class:"ddf_inicio", area:0,proceso:0})
      .then(  data => {id_prevfin=data.insertId;  });
    //this.nodes.push({id: "0",label: "A",role: "Inicio",class:"ddf_inicio"})
    this.area=[];
    this.procesos=[];
    this.rel_pa=[];
    await this.authService.service("/api/get_area",{id_raci:this.raci_id})
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                        
        for(var i=0;i<res.length;i++){
          //console.log("get_area");
          //console.log(res[i]);
          var tx_area= "";
          if(res[i].id_ant==0){
            tx_area=res[i].area
          }else{
            if(res[i].role.toString()==""){
              tx_area=res[i].area;
            }else{
              tx_area=res[i].role;
            }
          }
          this.area.push({ 
            foto:res[i].foto==null?"image-none.jpg":res[i].foto,
            id:res[i].id,
            area:tx_area,
            idx:res[i].idx,
            id_ant:res[i].id_ant
          });        
        }
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
    });  
    await this.authService.service("/api/get_proceso",{ id_raci:this.raci_id})
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //console.log(data);                    
        for(var i=0;i<res.length;i++){

          this.procesos.push( { valor_:res[i].valor_,valor:res[i].valor,
            id:res[i].id, 
            proceso:res[i].Titulo,
            descripcion:res[i].Descripcion,
            idx:res[i].idx,
            raci2:Number(res[i].id_raci2)}
          );
        }
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
    });
    await  this.authService.service("/api/get_pa_2",{ id_raci:this.raci_id })
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);             
        for(var i=0;i<res.length;i++){
          //console.log(res[i]);   
          if(res[i].rol=="R" || res[i].rol=="AR" ){
          this.rel_pa.push(
              {id:res[i].id,
              p:res[i].id_tarea,
              a:res[i].id_area,
              rol:res[i].rol,
              entregable:res[i].entregable,
              impacto:res[i].impacto,
              ttime:res[i].ttime,
              tipo_time:res[i].tipo_time,
              c:"X",
              valor:res[i].valor});
            }else if( res[i].rol=="C" ){
              this.rel_pa_C.push(
                {id:res[i].id,
                p:res[i].id_tarea,
                a:res[i].id_area,
                rol:res[i].rol,
                entregable:res[i].entregable,
                impacto:res[i].impacto,
                ttime:res[i].ttime,
                tipo_time:res[i].tipo_time,
                c:"X",
                valor:res[i].valor});
            }

        }        
       
        for(var j=0;j<this.procesos.length;j++){
          for(var i=0;i<this.area.length;i++){       
            var texto_proceso=""
            var id_proceso=0       
            for(var k=0;k<this.rel_pa.length;k++){
                if(this.rel_pa[k].a==this.area[i].id && 
                    this.rel_pa[k].p==this.procesos[j].id && 
                    (this.rel_pa[k].rol=='R' || this.rel_pa[k].rol=='AR')){
                      id_proceso=this.rel_pa[k].id
                      texto_proceso= "<b>"+this.area[i].area +"</b> realiza "+ this.procesos[j].proceso+
                      " consultado por: <b>"
                      var consultados=""
                      for(var l=0;l<this.rel_pa_C.length;l++){
                        if(this.rel_pa_C[l].p==this.procesos[j].id){
                          for(var m=0;m<this.area.length;m++){
                            if(this.rel_pa_C[l].a==this.area[m].id){
                              consultados+=this.area[m].area;
                            }
                          }
                        }
                      }
                      texto_proceso=texto_proceso+consultados+"</b>";
                      //console.log(texto_proceso)    
                       this.authService.service("/api/ins_nodes_graph",{ 
                            id_raci:this.raci_id, 
                            label: "A",
                            titulo:texto_proceso, 
                            area:this.area[i].id,
                            proceso:this.procesos[j].id,
                            class:"ddf_proceso"  })
                            .then(  
                                data => {    
                                  //console.log(id_prev)
                                  this.authService.service("/api/ins_links_graph",{
                                      id_raci:this.raci_id, 
                                      source:id_prev=="0"?id_previni:id_prev, 
                                      target:data.insertId,
                                      label:"-"})
                                  .then();
                                  id_prev=data.insertId;  
                                  //console.log(j) 

                                  
                                  

                            });
                


                      /*
                      this.nodes.push(
                        { 
                          id:this.rel_pa[k].id.toString(),
                          label: "A",
                          role: texto_proceso,
                          class:"ddf_proceso",
                          btn:false
                        }
                      )
                      //if(id_prev!="")
                      this.links.push(
                        {id: this.links.length+1, 
                          source: id_prev,
                          target: this.rel_pa[k].id.toString(),
                          label: 'dd' })
                      id_prev=this.rel_pa[k].id.toString();*/
                }    
            }                      
          }
          
        }
    

    
       
                                              
      this.authService.service("/api/ins_links_graph",{
        id_raci:this.raci_id, 
        source:id_prev, 
        target:id_prevfin,
        label:"-"})
    .then();
                                
        
       /* this.nodes.push(
          { 
            id:"-1".toString(),
            label: "A",
            role: "Fin",
            class:"ddf_inicio"
          }
        )*/
        
       

        //this.links = [...this.links];
        //this.nodes = [...this.nodes];    
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
      });  

   
      //console.log(this.nodes)
  }
  link={
    id: 'l371', 
    source: '401', 
    target: '407', 
    label: 'dd'
  }
  
  link_go(l){
    this.link={
      id: l.id.replace("l",""), 
      source:  l.source, 
      target:  l.target, 
      label:  l.label
    }

  }
  edit_link(){
    let postdata={
      link:this.link
    }
    
    console.log(postdata);
    console.log(this.links)
    console.log(this.nodes)
     this.authService.service("/api/upd_link_graph",postdata)
              .then(
                data => {
                  for(var i=0;i<this.links.length;i++){
                    //console.log("---"+this.links[i].id+""+this.link.id)
                    if(this.links[i].id=="l"+this.link.id){
                      //console.log("+"+this.link.source)
                      //console.log(this.link.target)
                      this.links[i].source=this.link.source;
                      this.links[i].target=this.link.target;
                    }
                  }
                  //this.links = [...this.links];  
                },
                error => {
                    var de= JSON.stringify(error);
                    var di = JSON.parse(de);
                });
  }

  edit_node(){ 
    if(this.validanodo()==false)return;
    let postdata={
      id:this.node.id,
      titulo:this.node.descripcion,
      class:this.node.class
    }
    //console.log(postdata);
     this.authService.service("/api/upd_nodes_graph",postdata)
              .then(
                data => {
                  var dat = JSON.stringify(data);
                  var res = JSON.parse(dat);      
                  var aux=[]
                  for(var i=0;i<this.nodes.length;i++){ 
                    if(this.nodes[i].id==this.node.id){
                      this.nodes[i].role=this.node.descripcion;    
                      this.nodes[i].class=this.node.class;  
                      aux.push(this.nodes[i])
                    }else{
                      aux.push(this.nodes[i])
                    }
                  }
                  this.nodes=aux;
                },
                error => {
                    var de= JSON.stringify(error);
                    var di = JSON.parse(de);
                });
    
    
  }
  edt_node(node){
    this.bndgda=false;
    this.node.id=node.id;    
    this.node.descripcion=node.role;    
    this.node.class=node.class;    
  }
  del_node(id){
    if(confirm("Desea eliminar el registro?")==false)return;
    this.node.id=id;    
    
     this.authService.service("/api/del_nodes_graph",{id:id.replace("b","")})
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);  
        //console.log(data);   
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          //swal.fire('¡Información incorrecta!', '', 'error');
      });  
      var aux=[]
    for(var i=0;i<this.nodes.length;i++){ if(this.nodes[i].id!=id){aux.push(this.nodes[i]) }}
    this.nodes=aux;
    var aux=[]
    for(var i=0;i<this.links.length;i++){ if(this.links[i].target!=id && this.links[i].source!=id){aux.push(this.links[i])}}
    this.links=aux;
  }
  draggingEnabled: boolean = true;
  panningEnabled: boolean = true;
  zoomEnabled: boolean = true;
  zoomSpeed: number = 0.1;
  minZoomLevel: number = 0.1;
  maxZoomLevel: number = 4.0;
  panOnZoom: boolean = true;
  autoZoom: boolean = false;
  autoCenter: boolean = false;   
  node={
    id:"",
    titulo:"",
    descripcion:"",
    class:""
  }
  nvo_node(id){
    this.node.descripcion=""
    this.node.titulo=""
    this.node.class=""
    this.bndgda=true;
    this.node.id=id;
  }
  bndgda=true;
  eli_link(){

    this.authService.service("/api/eli_links_graph",{id:this.link.id})
      .then(
        data=>{                  
          var aux_l=[]
          for(var i=0;i<this.links.length;i++){
            if(this.links[i].id!="l"+this.link.id){
              aux_l.push(this.links[i]);
            }
          }
          this.links=aux_l;
        }

      );


  }
  _go(c){

    this.router.navigateByUrl("http://www.garocedev.com/raci2/#/iniciopg")

  }
  validanodo(){
    if(this.node.descripcion==""){
      Swal.fire('Descripción incompleto!', '', 'error');
      return false;
    }
    if(this.node.class==""){
      Swal.fire('Tipo incompleto!', '', 'error');
      return false;
    }
    return true;
  }
  gda_node(){
    
    if(this.validanodo()==false)return;
    //console.log("si")
      var id_prev=""
      //console.log(this.node.class);
 
      if(this.node.class.includes("ddf_")){
        var node={ 
          id_raci:this.raci_id.toString(), 
          label:  this.node.titulo,
          titulo:this.node.descripcion, 
          area:0,
          proceso:0,
          class:this.node.class }
          //console.log(node)
         this.authService.service("/api/ins_nodes_graph",node)
        .then(  data => {  
          id_prev=data.insertId;
          this.nodes.push( {id: data.insertId.toString(), 
              label:  this.node.titulo,
              role: this.node.descripcion,
              class:this.node.class,
              btn:true}) 
        //this.nodes = [...this.nodes]; 
          this.authService.service("/api/ins_links_graph",{
            id_raci:this.raci_id, 
            source:this.node.id, 
            target:data.insertId,
            label:"-"})
        .then(
          data => {  
          this.links.push(
            {id: "l"+data.insertId,
              source: this.node.id,
              target: id_prev,
              label: ''
            })
          //this.links = [...this.links];  
          }
        );  
        });
        this.node.titulo=""
        this.node.descripcion=""
      }else{

        this.authService.service("/api/ins_links_graph",{
          id_raci:this.raci_id, 
          source:this.node.id, 
          target:this.node.class,
          label:"-"})
      .then(
        data => {  
        this.links.push(
          {id: "l"+data.insertId,
            source: this.node.id,
            target: this.node.class,
            label: ''
          })
        //this.links = [...this.links];  
        });  



      }


  }
}
